<template>
  <v-dialog v-model="dialog.show" persistent max-width="700">
    <v-card>
      <v-card-title class="pl-0 pr-0 pt-0 ml-0 mr-0 mt-0">
        <v-toolbar :color="this.getAppBarColor">
          <v-toolbar-title>
            <v-row dense justify="center" align="center">
              <v-col cols="12">
                <span class="align-center">
                  <p class="white--text">{{ dialog.title }}</p>
                </span>
              </v-col>
            </v-row>
          </v-toolbar-title>
        </v-toolbar>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-if="dialog.edit">
          <v-row dense>
            <v-col cols="4">
              <v-text-field
                v-model="form.precoRegioes['Norte']"
                :rules="[rules.required, rules.isNumber]"
                label="Preço Região Norte"
                prefix="$"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="form.precoRegioes['Centro-Oeste']"
                :rules="[rules.required, rules.isNumber]"
                label="Preço Região Centro-Oeste"
                prefix="$"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="form.percLicenciamentoCNH"
                :rules="[rules.required, rules.isNumber]"
                label="Percentual de Licenciamento CNH"
                suffix="%"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="form.ordem"
                :rules="[rules.required, rules.isNumber]"
                label="Ordem"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="form.anoModelo"
                :rules="[rules.required]"
                label="Ano"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="form.descricao"
                :rules="[rules.required]"
                label="Descrição"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="form.modeloIhs"
                :rules="[rules.required]"
                label="Modelo IHS"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <UploadFileImg
                @uploadedFile="form.foto = $event"
                :foto="form.foto"
                ref="uploadFileImg"
              />
            </v-col>
          </v-row>
        </v-form>

        <v-form ref="form" v-else>
          <v-row dense>
            <v-col cols="10">
              <SelectEmpresa
                :multiple="true"
                @onChanged="form.empresas = $event"
              />
            </v-col>
            <v-col cols="2">
              <v-checkbox v-model="form.ativo" label="Ativo"></v-checkbox>
            </v-col>
            <v-col cols="4">
              <SelectFabricante
                :multiple="false"
                @onChanged="form.fabricante = $event"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="form.anoModelo"
                :rules="[rules.required]"
                label="Ano"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="form.descricao"
                :rules="[rules.required]"
                label="Descrição"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="form.modeloIhs"
                :rules="[rules.required]"
                label="Modelo IHS"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="form.ordem"
                :rules="[rules.required, rules.isNumber]"
                label="Ordem"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="form.seguimento"
                :rules="[rules.required, rules.isNumber]"
                label="Seguimento"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="form.precoRegioes['Norte']"
                :rules="[rules.required, rules.isNumber]"
                label="Preço Região Norte"
                prefix="$"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="form.precoRegioes['Centro-Oeste']"
                :rules="[rules.required, rules.isNumber]"
                label="Preço Região Centro-Oeste"
                prefix="$"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="form.percLicenciamentoCNH"
                :rules="[rules.required, rules.isNumber]"
                label="Percentual de Licenciamento CNH"
                suffix="%"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <UploadFileImg
                @uploadedFile="form.foto = $event"
                :foto="form.foto"
                ref="uploadFileImg"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="save()"
          >Salvar</v-btn
        >

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Veiculo from "@/services/veiculo";
import rules from "@/utils/rules";

export default {
  name: "DialogFormVeiculo",

  components: {
    UploadFileImg: () => import("./UploadFileImg"),
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
    SelectFabricante: () => import("@/components/select/SelectFabricante"),
  },

  data() {
    return {
      dialog: {
        title: "",
        show: false,
        edit: true,
      },
      form: {
        anoModelo: "",
        ativo: true,
        dataCriacao: null,
        descricao: "",
        empresas: [],
        fabricante: "",
        foto: "",
        modeloIhs: "",
        ordem: 0,
        seguimento: 0,
        percLicenciamentoCNH: 0,
        precoRegioes: {
          "Centro-Oeste": 0,
          Norte: 0,
        },
      },
      veiculoId: "",
      rules,
      veiculoService: new Veiculo(),
    };
  },

  methods: {
    show(edit, veiculo) {
      if (edit) {
        this.editItem(veiculo);
      } else {
        this.form.dataCriacao = new Date();
        this.dialog.title = "Criar Novo Veiculo";
      }
      this.dialog.edit = edit;
      this.dialog.show = true;
    },

    editItem(veiculo) {
      this.dialog.title = "Editar Veiculo";
      this.veiculoId = veiculo.id;
      this.form.anoModelo = veiculo.anoModelo;
      this.form.dataCriacao = veiculo.dataCriacao;
      this.form.descricao = veiculo.descricao;
      this.form.empresas = veiculo.empresas;
      this.form.fabricante = veiculo.fabricante;
      this.form.foto = veiculo.foto;
      this.form.modeloIhs = veiculo.modeloIhs;
      this.form.ordem = veiculo.ordem;
      this.form.seguimento = veiculo.seguimento;
      this.form.precoRegioes["Centro-Oeste"] =
        veiculo.precoRegioes["Centro-Oeste"];
      this.form.precoRegioes["Norte"] = veiculo.precoRegioes["Norte"];
      this.form.percLicenciamentoCNH = veiculo.percLicenciamentoCNH;
    },

    async save() {
      try {
        if (this.$refs.form.validate()) {
          this.convertValuesTofloat();
          if (this.dialog.edit) {
            await this.veiculoService.update(this.veiculoId, this.form);
            this.$emit("updated", [this.form, this.veiculoId]);
          } else {
            let newVeiculo = await this.veiculoService.create(this.form);
            this.$emit("created", newVeiculo);
          }
          this.close();
        }
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    close() {
      this.dialog.show = false;
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.$refs.uploadFileImg.reset();
    },

    convertValuesTofloat() {
      this.form.precoRegioes["Centro-Oeste"] = parseFloat(
        this.form.precoRegioes["Centro-Oeste"]
      );
      this.form.precoRegioes["Norte"] = parseFloat(
        this.form.precoRegioes["Norte"]
      );
      this.form.ordem = parseFloat(this.form.ordem);
      this.form.seguimento = parseFloat(this.form.seguimento);
      this.form.percLicenciamentoCNH = parseFloat(
        this.form.percLicenciamentoCNH
      );
    },
  },
};
</script>
